// import React, { useState } from "react";
// import "./Leadership.css";
// import { X, ChevronLeft, ChevronRight } from "lucide-react";

// const DEFAULT_LINKEDIN =
//   "https://www.linkedin.com/company/vensap/?viewAsMember=true";

// const Leadership = ({ members, member, index }) => {
//   const [open, setOpen] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(index);

//   const currentMember = members[currentIndex];

//   const nextProfile = () => {
//     setCurrentIndex((prev) =>
//       prev === members.length - 1 ? 0 : prev + 1
//     );
//   };

//   const prevProfile = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? members.length - 1 : prev - 1
//     );
//   };

//   const openLinkedIn = () => {
//     window.open(
//       currentMember.linkedin || DEFAULT_LINKEDIN,
//       "_blank",
//       "noopener,noreferrer"
//     );
//   };

//   return (
//     <>
//       {/* CARD */}
//       <div
//         className="leadership-box"
//         onClick={() => {
//           setCurrentIndex(index);
//           setOpen(true);
//         }}
//       >
//         <div className="leadership-image-wrapper">
//           <img
//             src={member.image}
//             alt={member.name}
//             className="leadership-image"
//           />

//           <div className="leadership-info">
//             <h3>{member.name}</h3>
//             <p>{member.role}</p>
//           </div>
//         </div>
//       </div>

//       {/* MODAL */}
//       {open && (
//         <div
//           className="leadership-modal-overlay"
//           onClick={() => setOpen(false)}
//         >
//           <div
//             className="leadership-modal"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* ACTIONS */}
//             <div className="leadership-modal-actions">
//               <button
//                 className="action-btn light-btn"
//                 onClick={prevProfile}
//               >
//                 <ChevronLeft size={22} />
//               </button>

//               <button
//                 className="action-btn dark-btn"
//                 onClick={nextProfile}
//               >
//                 <ChevronRight size={22} />
//               </button>

//               <button
//                 className="close-btn"
//                 onClick={() => setOpen(false)}
//               >
//                 <X size={26} />
//               </button>
//             </div>

//             {/* CONTENT */}
//             <div className="leadership-modal-content">
//               {/* IMAGE */}
//               <div className="modal-image-section">
//                 <div className="diamond-shape">
//                   <img
//                     src={currentMember.image}
//                     alt={currentMember.name}
//                     className="diamond-image"
//                   />
//                 </div>
//               </div>

//               {/* DETAILS */}
//               <div className="modal-details">
//                 <h2>{currentMember.name}</h2>

//                 <h4>{currentMember.role}</h4>

//                 <div
//                   className="linkedin-icon"
//                   onClick={openLinkedIn}
//                   style={{ cursor: "pointer" }}
//                   title="View LinkedIn Profile"
//                 >
//                   <i className="bi bi-linkedin"></i>
//                 </div>

//                 <div className="modal-description">
//                   <p>
//                     {currentMember.description ||
//                       "Leadership profile description goes here."}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Leadership;

import React, { useState, useEffect } from "react";
import "./Leadership.css";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const DEFAULT_LINKEDIN =
  "https://www.linkedin.com/company/vensap/?viewAsMember=true";

const Leadership = ({ members, member, index }) => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(index);

  useEffect(() => {
    setCurrentIndex(index);
  }, [index]);

  const currentMember = members[currentIndex];

  const nextProfile = () => {
    setCurrentIndex((prev) =>
      prev === members.length - 1 ? 0 : prev + 1
    );
  };

  const prevProfile = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? members.length - 1 : prev - 1
    );
  };

  const openLinkedIn = () => {
    window.open(
      currentMember.linkedin || DEFAULT_LINKEDIN,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      {/* CARD */}
      <div
        className="leadership-box"
        onClick={() => {
          setCurrentIndex(index);
          setOpen(true);
        }}
      >
        <div className="leadership-image-wrapper">
          <img
            src={member.image}
            alt={member.name}
            className="leadership-image"
            style={{ objectPosition: member.objectPosition || "center top" }}
          />

          <div className="leadership-info">
            <h3>{member.name}</h3>
            <p>{member.role}</p>
          </div>
        </div>
      </div>

      {/* MODAL */}
      {open && (
        <div
          className="leadership-modal-overlay"
          onClick={() => setOpen(false)}
        >
          <div
            className="leadership-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* ACTIONS */}
            <div className="leadership-modal-actions">
              <button className="action-btn light-btn" onClick={prevProfile}>
                <ChevronLeft size={20} />
              </button>

              <button className="action-btn dark-btn" onClick={nextProfile}>
                <ChevronRight size={20} />
              </button>

              <button className="close-btn" onClick={() => setOpen(false)}>
                <X size={22} />
              </button>
            </div>

            {/* CONTENT */}
            <div className="leadership-modal-content">
              {/* IMAGE */}
              <div className="modal-image-section">
                <div className="diamond-shape">
                  <img
                    src={currentMember.image}
                    alt={currentMember.name}
                    className="diamond-image"
                    style={{
                      objectPosition:
                        currentMember.objectPosition || "center top",
                    }}
                  />
                </div>
              </div>

              {/* DETAILS */}
              <div className="modal-details">
                <h2>{currentMember.name}</h2>

                <h4>{currentMember.role}</h4>

                <div
                  className="linkedin-icon"
                  onClick={openLinkedIn}
                  style={{ cursor: "pointer" }}
                  title="View LinkedIn Profile"
                >
                  <i className="bi bi-linkedin"></i>
                </div>

                <div className="modal-description">
                  <p>
                    {currentMember.description ||
                      "Leadership profile description goes here."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Leadership;